<template>

  <main class="videos-page">

    <header class="page-head">
      <h1>آرشیو ویدئوهای ورزشی</h1>
      <p class="lead">کلیپ‌های منتخب مسابقات کشتی و فوتبال از منابع رسمی — فینال‌ها، ضربه‌های فنی و لحظه‌های طلایی</p>
    </header>

    <!-- چیپ تگ‌ها -->
    <nav v-if="tags.length" class="tag-chips" aria-label="فیلتر برچسب‌ها">
      <router-link
          class="chip"
          :class="{ active: !activeTag }"
          to="/videos"
      >همه</router-link>
      <router-link
          v-for="t in tags"
          :key="t.tag"
          class="chip"
          :class="{ active: activeTag === t.tag }"
          :to="`/videos/tag/${encodeURIComponent(t.tag)}`"
      >{{ t.tag }} <span class="count">{{ t.count }}</span></router-link>
    </nav>

    <!-- حالت لودینگ -->
    <div v-if="loading" class="state-box">در حال بارگذاری ویدئوها…</div>

    <!-- خالی -->
    <div v-else-if="!videos.length" class="state-box">
      <p>ویدئویی در این بخش منتشر نشده است.</p>
      <router-link class="back-link" to="/videos">بازگشت به همهٔ ویدئوها</router-link>
    </div>

    <!-- گرید -->
    <div v-else class="vgrid">
      <router-link
          v-for="v in videos"
          :key="v.id"
          class="vcard"
          :to="`/video/${v.slug}`"
      >
        <div class="thumb-box">
          <img
              v-if="v.thumbnailUrl"
              :src="v.thumbnailUrl"
              :alt="v.title"
              loading="lazy"
          >
          <div v-else class="no-thumb">▶</div>
          <span v-if="v.durationSec" class="dur">{{ durFa(v.durationSec) }}</span>
          <span class="play-badge">▶</span>
        </div>
        <div class="vbody">
          <strong class="vtitle">{{ v.title }}</strong>
          <span v-if="v.publishedAt" class="vdate">{{ faDate(v.publishedAt) }} · {{ v.views ? v.views.toLocaleString('fa-IR') + ' بازدید' : 'جدید' }}</span>
        </div>
      </router-link>
    </div>

    <!-- صفحه‌بندی -->
    <nav v-if="pages > 1" class="pager" aria-label="صفحه‌بندی">
      <router-link
          v-if="page > 1"
          class="pg"
          :to="pagePrev"
      >← قبلی</router-link>
      <span class="pg-label">صفحهٔ {{ faNum(page) }} از {{ faNum(pages) }}</span>
      <router-link
          v-if="page < pages"
          class="pg"
          :to="pageNext"
      >بعدی →</router-link>
    </nav>

  </main>

</template>

<script>
import api from '@/services/api'
import { setSeo } from '@/utils/seo'

export default {

  name: 'VideosPage',

  data() {
    return {
      videos: [],
      tags: [],
      total: 0,
      page: 1,
      pages: 1,
      loading: true,
    }
  },

  computed: {
    activeTag() {
      return this.$route.params.tag ? decodeURIComponent(this.$route.params.tag) : null
    },
    pagePrev() {
      if (!this.activeTag) return this.page > 2 ? `/videos/page/${this.page - 1}` : '/videos'
      return this.page > 2 ? `/videos/tag/${encodeURIComponent(this.activeTag)}/page/${this.page - 1}` : `/videos/tag/${encodeURIComponent(this.activeTag)}`
    },
    pageNext() {
      if (!this.activeTag) return `/videos/page/${this.page + 1}`
      return `/videos/tag/${encodeURIComponent(this.activeTag)}/page/${this.page + 1}`
    },
  },

  watch: {
    '$route.params.tag'() { this.load() },
    '$route.params.page'() { this.load() },
  },

  async created() {
    this.loadTags()
    await this.load()
  },

  methods: {
    faDate(d) {
      return new Date(d).toLocaleDateString('fa-IR')
    },
    faNum(n) {
      return String(n).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
    durFa(sec) {
      const m = Math.floor(sec / 60)
      const s = String(sec % 60).padStart(2, '0')
      return `${m}:${s}`
    },

    async loadTags() {
      try {
        this.tags = await api.request('/videos/tags') || []
      } catch (e) {
        this.tags = []
      }
    },

    async load() {
      this.loading = true
      this.activeTag2 = null

      const tag = this.$route.params.tag ? decodeURIComponent(this.$route.params.tag) : null
      const page = parseInt(this.$route.params.page, 10) || 1

      try {
        const q = new URLSearchParams({ page: String(page), limit: '24' })
        if (tag) q.set('tag', tag)
        const res = await api.request(`/videos?${q}`)

        this.videos = res?.videos || []
        this.total = res?.total || 0
        this.page = res?.page || 1
        this.pages = res?.pages || 1

        setSeo({
          title: tag
            ? `ویدئوهای ${tag} | ضربه آزاد`
            : 'آرشیو ویدئوهای ورزشی | کشتی و فوتبال | ضربه آزاد',
          description: tag
            ? `کلیپ‌های ویدئویی برچسب ${tag} — فینال‌ها و لحظه‌های طلایی مسابقات در ضربه آزاد`
            : 'آرشیو ویدئو و کلیپ‌های ورزشی مسابقات کشتی و فوتبال از منابع رسمی — پخش مستقیم و سبک در ضربه آزاد',
          image: (this.videos[0] && this.videos[0].thumbnailUrl) || null,
          path: tag ? `/videos/tag/${tag}` : '/videos',
        })
      } catch (e) {
        console.error('VideosPage:', e)
        this.videos = []
      } finally {
        this.loading = false
      }
    },
  },

}

</script>

<style scoped lang="scss">

.videos-page {
  width: 100%;
  margin: 0 auto;
  padding: 20px 16px 40px;
  box-sizing: border-box;
}

.page-head {
  margin-bottom: 16px;

  h1 {
    margin: 0 0 6px;
    font-size: 1.5rem;
    color: #0f172a;
  }

  .lead {
    margin: 0;
    color: #64748b;
    font-size: 0.95rem;
    line-height: 1.8;
  }
}

.tag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;

  .chip {
    padding: 6px 14px;
    border-radius: 999px;
    background: #fff;
    color: #334155;
    font-size: 0.85rem;
    font-weight: 600;
    text-decoration: none;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .05);

    .count {
      color: #94a3b8;
      font-weight: 400;
    }

    &.active {
      background: #0f766e;
      color: #fff;

      .count {
        color: rgba(255, 255, 255, .7);
      }
    }
  }
}

.state-box {
  padding: 48px 16px;
  text-align: center;
  color: #64748b;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, .05);
}

.back-link {
  display: inline-block;
  margin-top: 10px;
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.vgrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.vcard {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .05);
  transition: transform .2s ease, box-shadow .2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, .09);

    .play-badge {
      opacity: 1;
      transform: scale(1);
    }
  }

  .thumb-box {
    position: relative;
    aspect-ratio: 16 / 9;
    background: linear-gradient(135deg, #022c22, #064e3b);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .no-thumb {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, .85);
      font-size: 2rem;
    }

    .dur {
      position: absolute;
      bottom: 8px;
      left: 8px;
      background: rgba(0, 0, 0, .75);
      color: #fff;
      font-size: 0.72rem;
      padding: 2px 7px;
      border-radius: 6px;
      direction: ltr;
    }

    .play-badge {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(.85);
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background: rgba(15, 118, 110, .92);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.1rem;
      opacity: .92;
      transition: all .2s ease;
    }
  }

  .vbody {
    padding: 10px 12px 12px;

    .vtitle {
      display: block;
      color: #0f172a;
      font-size: 0.92rem;
      line-height: 1.6;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .vdate {
      display: block;
      margin-top: 6px;
      color: #94a3b8;
      font-size: 0.75rem;
    }
  }
}

.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 22px;

  .pg {
    padding: 8px 18px;
    background: #fff;
    border-radius: 10px;
    color: #0f766e;
    font-weight: 700;
    text-decoration: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .06);
  }

  .pg-label {
    color: #64748b;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .videos-page {
    padding: 14px 12px 32px;
  }

  .vgrid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}

</style>
